import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-[#333333] text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-8">
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_equipease-pro/artifacts/k9cg4lku_3partlogoEE%20%28500%20x%20250%20px%29.png"
              alt="EquipEASE Lease Co."
              className="h-16 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-gray-300">
              Equipment financing for Canadian businesses. Flexible solutions tailored to your needs.
            </p>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4 text-[#FF9933]">Contact</h4>
            <p className="text-gray-300 mb-2">
              Phone: <a href="tel:1-844-250-3273" className="text-[#FF6600] hover:text-[#FF9933] transition-colors">1-844-250-EASE</a>
            </p>
            <p className="text-gray-300 mb-4">Email: info@equipease.ca</p>
            
            <div className="flex space-x-4 mt-4">
              <a 
                href="https://www.instagram.com/equipease/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-[#FF6600] hover:bg-[#FF9933] rounded-full flex items-center justify-center transition-colors"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
              <a 
                href="https://www.facebook.com/equipease/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-[#FF6600] hover:bg-[#FF9933] rounded-full flex items-center justify-center transition-colors"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4 text-[#FF9933]">Quick Links</h4>
            <ul className="space-y-2 text-gray-300">
              <li><a href="/#pre-approval" className="hover:text-[#FF6600] transition-colors">Get Pre-Approved</a></li>
              <li><a href="/applynow" className="hover:text-[#FF6600] transition-colors">Apply Now</a></li>
              <li><a href="/businessloans" className="hover:text-[#FF6600] transition-colors">Business Loans</a></li>
              <li><a href="#why-choose" className="hover:text-[#FF6600] transition-colors">Why Choose Us</a></li>
              <li><a href="#contact" className="hover:text-[#FF6600] transition-colors">Contact</a></li>
              <li><a href="#industries" className="hover:text-[#FF6600] transition-colors">Industries</a></li>
              <li><a href="/blog" className="hover:text-[#FF6600] transition-colors">Blog</a></li>
              <li><a href="/coverages" className="hover:text-[#FF6600] transition-colors">Extra Coverages</a></li>
              <li><a href="/privacy" className="hover:text-[#FF6600] transition-colors">Privacy Policy</a></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-[#4A4A4A] mt-8 pt-8 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} EquipEASE Lease Co. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;